// The name a downloaded VQQ export is saved under. A stored VQQ name carries the request's due
// date, so VQQ rows use the file name the export returned, which carries the release date. Library
// rows keep their own "Diligent-{document}-{requested on}" convention.
export const exportSaveName = ({ isDocLibrary, details, exportFileName }) =>
  isDocLibrary
    ? `Diligent-${details?.document_name}-${details?.requested_on}`
    : exportFileName || details?.name;
